import React from 'react';
import { useAppSelector, useAppDispatch } from 'app/hooks';
import { selectSelectedDatabase, setSelectedDatabase } from 'app/snowflakeSlice';
import { clearSelectedObjects } from '../../data-product-builder/reducers/builderSlice';
import StepWrapper from 'components/StepWrapper';
import DatabaseSelector from 'components/DatabaseSelector';

export interface ProductionDatabaseStepProps {
  onBack: () => void;
  onContinue: () => void;
}

export default function ProductionDatabaseStep(props: ProductionDatabaseStepProps): JSX.Element {
  const dispatch = useAppDispatch();
  const selectedDatabase = useAppSelector(selectSelectedDatabase);

  /* eslint-disable @typescript-eslint/strict-boolean-expressions */
  return (
    <StepWrapper
      title="Which database would you like to create infrastructure configurations from?"
      subtitle="Select database"
      onBack={() => props.onBack()}
      onContinue={() => props.onContinue()}
      continueDisabled={selectedDatabase === ''}
    >
      <div className="min-h-full flex flex-col">
        <DatabaseSelector
          onSelect={(database) => {
            dispatch(clearSelectedObjects());
            dispatch(setSelectedDatabase(database));
          }}
          selectedDatabases={selectedDatabase !== '' ? [selectedDatabase] : []}
        />
      </div>
    </StepWrapper>
  );
}
